<script>
import { mapState, mapActions, mapMutations } from 'vuex';

export default {
  name: 'ForgotPassword',
  data() {
    return {
      success: null,
    };
  },
  computed: {
    ...mapState('user', [
      'user',
      'errors',
    ]),
    email: {
        get() {
          return this.user.email || null;
        },
        set(value) {
          const { user } = this;
          user.email = value;
          this.setUser(user)
        },
    },
  },
  methods: {
    ...mapActions('user', [
      'fetchRequestPasswordChange',
    ]),
    ...mapMutations('user', [
      'setUser',
      'addError',
      'resetErrors',
    ]),
    requestPasswordChange() {
      this.resetErrors();
      const regex = new RegExp('\S+@\S+\.\S+');
      if (!regex.test(this.email)) {
        this.addError("Nieprawidłowy e-mail!");
        return;
      }
      this.fetchRequestPasswordChange()
        .then(res => {
          if (res) {
            this.success = true;
          }
        })
    },
  }
};
</script>
<template>
    <div id="forgotPassword" class="pb-5 bg-white">
        <div class="bg-white pt-5 pb-5">
            <h1 class="text-center">Zapomniałeś hasła?</h1>
        </div>
        <div id="login" class="text-center">
            <div class="wrapper text-left">
                <div class="container d-flex flex-column">
                    <label for="email">Email</label>
                    <input id="email" class="mb-3" v-model="email" />

                    <div class="errors" v-if="errors.length > 0">
                        <div v-for="error in errors">{{ error }}</div>
                    </div>

                    <div class="alert-success mt-3 p-3" v-if="success">
                        Wysłaliśmy email z instrukcją zmiany hasła
                    </div>

                    <div class="text-center">
                        <button @click="requestPasswordChange">
                            Wyślij email
                        </button>
                    </div>

                    <div class="d-flex justify-content-center mt-3 footer-links">
                        <router-link :to="{ name: 'register' }" class="mr-3">
                            Zarejestruj się
                        </router-link>
                        <router-link :to="{ name: 'login' }">
                            Logowanie
                        </router-link>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
